<template>
  <div class="help-page">
    <Tree></Tree>
    <Reviews :html="html"></Reviews>
    <div class="ball" @click="openSearch">
      <i class="icon iconfont iconicon_search1"></i>
    </div>
    <SearchBox v-model="show" v-if="show"></SearchBox>
  </div>
</template>
<script>
import api from '@/services/api/help/help'
import Reviews from '@/views/backStage/reviews'
import Tree from './tree'
import SearchBox from './searchBox'
import bus from '@/bus'
export default {
  components: {
    Tree,
    Reviews,
    SearchBox
  },
  watch: {
    '$route.query': {
      handler() {
        let document_draft_id = Number(this.$route.query.id || 0)
        this.keyword = this.$route.query.keyword
        if(!document_draft_id) return
        this.active = document_draft_id
        this.openDocument(document_draft_id)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      html: '',
      keyword: '',
      show: false
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    async openDocument(id) {
      let result =  await api.documentRead({document_draft_id: Number(id)})
      if(this.keyword) {
        let reg = new RegExp(`(<[^>]+>[^<]*?)(${this.keyword})([^<]*?<\/[^>]+>)`)
        this.html = result.document_content ? result.document_content.replace(reg, `$1<span class="keyword" id="keyword">${this.keyword}</span>$3`) : ''
        this.$nextTick(() => {
          // document.querySelector('#keyword').scrollIntoView({ behavior: 'smooth' })
          let keyDom = document.querySelector('#keyword')
          if(!keyDom) return
          setTimeout(() => {
            document.querySelector('#reviews').scrollTo({
              top: keyDom.offsetTop - 100,
              behavior: 'smooth'
            })
          }, 100)
        })
      } else {
        this.html = result.document_content
      }
    },
    openSearch() {
      this.show = true
    },
    getAllNodes(element){
      const nodes = []
      let traverse = (node) => {
        nodes.push(node)
        const children = node.childNodes
        for (let i = 0;i< children.length; i++) {
          traverse(children[i])
        }
      }
      traverse(element)
      return nodes
    }
  }
}
</script>
<style lang="scss">
.help-page {
  display: flex;
  width: 100%;
  position: relative;
  .help-reviews {
    width: 0;
    flex: 1;
  }
  .ball {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    flex-shrink: 0;
    background: linear-gradient(225deg, #2FA9FF 0%, #0D70E8 100%);
    position: absolute;
    right: 270px;
    bottom: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    z-index: 2;
    cursor: pointer;
    i {
      font-size: 20px;
    }
    box-shadow: 0 7px 24px 0 rgba(47, 169, 255, 0.8);
  }
}
</style>
